export enum TokenType {
    ResetPassword = 'resetPassword',
    ForgotPassword = 'forgotPassword',
    VerifyEmail = 'verifyEmail',
    Uuid = 'uuid'
}